/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { Snackbar, Alert } from '@mui/material';
import Styles from '../css/GlobalSnackbar.module.css';
import { useNavigationAlert } from '../contexts/NavigationAlertContext';

const GlobalSnackbar = () => {
  const { alert, setAlert, status, setStatus } = useNavigationAlert();
  if (!alert) return null;
  return (
    <Snackbar
      open={!!alert}
      onClose={() => {
        setAlert(null);
        setStatus(null);
      }}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      ClickAwayListenerProps={{ onClickAway: () => null }}
    >
      <Alert
        onClose={() => {
          setAlert(null);
          setStatus(null);
        }}
        severity={status}
        variant='filled'
        className={Styles.alert}
      >
        {alert}
      </Alert>
    </Snackbar>
  );
};

export default GlobalSnackbar;
